import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";

import { useDeliveryLocations } from "../useDeliveryLocations";
import { requestCreateDeliveryLocation } from "./createDeliveryLocation.request";
import { CreateDeliveryLocationBody } from "./createDeliveryLocation.types";

const useCreateDeliveryLocation = (
  options?: MutationOptions<
    void,
    ApiServiceError<ApiError>,
    CreateDeliveryLocationBody
  >
) => {
  const { t } = useTranslation();

  const { refetch: refetchDeliveryLocations } = useDeliveryLocations({
    enabled: false
  });

  return useMutation({
    mutationFn: requestCreateDeliveryLocation,
    ...options,
    onSuccess: (data, variables, context) => {
      const getToastMessage = () => {
        if (variables.areaName) {
          return t("Area created successfully");
        }

        if (variables.cityName) {
          return t("City created successfully");
        }

        return t("Country created successfully");
      };

      refetchDeliveryLocations();
      toast.success(getToastMessage());
      options?.onSuccess?.(data, variables, context);
    }
  });
};

export default useCreateDeliveryLocation;
